// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a3641f03","453":"e5a338a6","455":"6bd47967"}[chunkId] + ".chunk.js";
};